import { useTranslation } from "react-i18next";

/**
 * Single-brace placeholders supported by the return engine's
 * stringTemplateInterpretation (V1 parity) — shown under the text fields of
 * the Shopify order actions.
 */
const RETURN_TEXT_PLACEHOLDERS = [
  "{orderName}",
  "{orderId}",
  "{firstName}",
  "{lastName}",
  "{trackingCode}",
  "{resolutions}",
  "{returnRequestId}",
] as const;

export function ReturnPlaceholdersHint() {
  const { t } = useTranslation("trackoffice");

  return (
    <p className="mt-1 text-[10px] text-muted-foreground">
      {t(
        "workflowsEditor.returnOrderActions.placeholdersHint",
        "Available placeholders:",
      )}{" "}
      <span className="font-mono">{RETURN_TEXT_PLACEHOLDERS.join(" ")}</span>
    </p>
  );
}
